import gql from 'graphql-tag';

export const CLOSE_DEAL = gql`
  mutation CloseDeal($input: CloseDealInput!) {
    bpf {
      result: closeDeal(input: $input) {
        error
        success
        entity {
          id
          reasonId
          isClosed
          reasonLabel
          closedDateTime
          closeDealStatus
          department {
            id
            name
          }
        }
      }
    }
  }
`;
